import { IPaging } from '../paging.interface';

export enum EventType {
    Sale = 0,
    Bonus = 1,
    Click = 2
}

export interface ISaleLogsModel {
    items: IPaging<ISaleLogsItemModel>;
    earningVisible: boolean;
}

export interface ISaleLogsItemModel {
    date: Date;
    companyId: number;
    officeName: string;
    customerEmail: string;
    agentId: number;
    siteId: number;
    sitename: string;
    agent: string;
    typename: string;
    clickId: number;
    earning: number;
    payout: number;
    eventType: EventType;
}

export function translateEventType(src: EventType): string {
    switch (src) {
        case EventType.Sale:
            return 'Sale';
        case EventType.Bonus:
            return 'Bonus';
        case EventType.Click:
            return 'Click';
        default:
            return '';
    }
}
